<template>
  <page-template type="norightpanel" class="action-collaborative">
    <template v-slot:toolbar>
        <tool-bar @status-change="status = $event" type="operations-action-collaborative" title="Actions collaboratives" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div class="d-flex rectangular-element-container">
          <rectangular-element
            v-for="action in cachedActions"
            :key="action._id"
            :title="action.title"
            :date="action.dateStart"
            :guide="getCatById(action.category)"
            :actions="items"
            :id="action._id"
            :publish-url="`${apiURL}/collaborative/order/status/${action._id}/activated`"
            :publish-object="action"
            @update="updateActions()"
            :class="action.activated ? 'on-going' : 'to-publish'"
          ></rectangular-element>
          <rectangular-element-new title="Nouvelle action" link="/action-collaborative/new"></rectangular-element-new>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import rectangularElementNew from '@/components/RectangularElementNew.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'ActionCollaborative',
    components: { pageTemplate, toolBar, rectangularElement, rectangularElementNew },
    data: () => {
      return {
        status: false,
        actions: [],
        actionCategories: [],
        apiURL
      }
    },
    async created () {
      try {
        // ALL COLLABORATIVE ACTIONS
        const actionsRes = await axios.get(`${apiURL}/collaborative/orders/all`)
        this.actions = actionsRes.data.model
        // GET LIST OF COLLABORATIVE ACTIONS CATEGORIES
        const actionCategoriesRes = await axios.get(`${apiURL}/data/ads/category`)
        this.actionCategories = actionCategoriesRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    },
    computed: {
      cachedActions () {
        if (!this.actions.length) return []
        return this.actions.filter(a => {
          return a.done === this.status
        })
      },
      items () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.editCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.openCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.duplicateCb },
          { title: 'Réponses', icon: 'mdi-chart-bar', callback: this.answersCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.deactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.deleteCb }
        ]
      }
    },
    methods: {
      getCatById (id) {
        const cats = this.actionCategories.filter(c => {
          return c._id === id
        })
        return cats.length ? cats[0].name : ''
      },
      async updateActions () {
        try {
          this.$store.dispatch('loading')
          // ALL COLLABORATIVES ACTIONS
          const actionRes = await axios.get(`${apiURL}/collaborative/orders/all`)
          this.actions = actionRes.data.model
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // EDIT COLLABORATIVE ACTION
      editCb (id) {
        this.$router.push(`/action-collaborative/edit/${id}`)
      },
      // OPEN COLLABORATIVE ACTION
      openCb (id) {
        this.$router.push(`/action-collaborative/open/${id}`)
      },
      // DUPLICATE COLLABORATIVE ACTION
      async duplicateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.post(`${apiURL}/collaborative/order/duplicate/${id}`)
          await this.updateActions()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // GO TO ANSWERS
      answersCb (id) {
        this.$router.push(`/action-collaborative/reponses/${id}`)
      },
      // DEACTIVATE COLLABORATIVE ACTION
      async deactivateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.put(`${apiURL}/collaborative/order/status/${id}/unactivated`)
          await this.updateActions()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE COLLABORATIVE ACTION
      async deleteCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.delete(`${apiURL}/collaborative/order/${id}`)
          await this.updateActions()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>